import React from "react";
import { FormControl, InputLabel, Select as MuiSelect } from "@mui/material";
import { Field } from "formik";

const Select = ({ name, label, children }) => {
  return (
    <Field name={name}>
      {({ field }) => (
        <FormControl fullWidth variant="standard">
          <InputLabel shrink>{label}</InputLabel>
          <MuiSelect variant="standard" displayEmpty {...field}>
            {children}
          </MuiSelect>
        </FormControl>
      )}
    </Field>
  );
};

export default Select;
